import CryptoJS from "crypto-js";
import md5 from "md5";

export const query = (name, searchParams) => {
  const urlParams = new URLSearchParams(
    searchParams || window.location.href.split("?")?.[1]
  );
  return urlParams.get(name);
};

// 配置路径
const systemConfigPath = "system/v2/getSystemConfig";
// 验签数值
const signatureTenantCode = "getSystemConfig";

// 是否 http/https
export function isHttpLink(url) {
  const httpRegex = /^https?:\/\/[^ "]+$/;

  return httpRegex.test(url);
}

/**
 * 返回 url 中 pathname 不包含 第一个 / 的 url
 * 示例：https://abc.com/biz/system/getSystemConfig?abc=111 => system/getSystemConfig
 */
export function filterUrlPathName(url) {
  const urlPathname = new URL(url).pathname;
  const urlPathArr = urlPathname.split("/");

  return urlPathArr.slice(2).join("/") || "";
}

// 生成随机字符串
export function generateRandomString(length) {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let result = "";
  const charactersLength = chars.length;

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

// 生成接口签名
export function generateSignature(url, str) {
  const timestamp = Date.now();
  const param = timestamp + url + md5(str + timestamp);
  const nonce = generateRandomString(8);
  const slat = "Y0m1^@1k";
  const shaStr = CryptoJS.SHA1(`${slat}~${param}-${nonce}`);
  const signature = nonce.substring(0, 4) + shaStr + nonce.substring(4, 8);

  return {
    timestamp,
    signature,
  };
}

// 验签请求拦截
export const signatureInterceptorsRequest = (config) => {
  if (config.url) {
    let requestUrl;

    if (isHttpLink(config.url)) {
      requestUrl = filterUrlPathName(config.url);
    } else {
      requestUrl = filterUrlPathName(config.baseURL + config.url);
    }

    let tenantCode = sessionStorage.getItem("tenantCode");

    if (requestUrl === systemConfigPath) {
      tenantCode = signatureTenantCode;
    }

    if (tenantCode) {
      const {signature, timestamp} = generateSignature(requestUrl, tenantCode);
      config.headers.set("signature", signature);
      config.headers.set("timestamp", timestamp);
    }
  }

  return config;
};
